import { APP_NAME } from "./constants";
import type { Song } from "./types";

export default function getPageTitle({ song }: { song: Song }) {
  let title = APP_NAME;
  if (song) {
    title = `${song.title}`;
    if (song.artist) {
      title += ` - ${song.artist}`;
    }
  }
  return title;
}
